if (!window.__kbxSizePickerInit) {
  window.__kbxSizePickerInit = true;

const addToCart = async (variantId) => {
  const cartDrawer = document.querySelector('cart-drawer');
  const sectionsToRender = cartDrawer?.getSectionsToRender().map((s) => s.id) || [];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  if (sectionsToRender.length) {
    formData.append('sections', sectionsToRender.join(','));
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: formData,
  });

  if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);

  const data = await response.json();
  if (cartDrawer) {
    cartDrawer.renderContents(data);
  }
};

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const btn = event.target.closest('.card__size-btn');
  if (!btn || btn.dataset.unavailable === 'true') return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  btn.setAttribute('aria-disabled', 'true');

  addToCart(variantId)
    .catch((err) => console.warn('[size-picker] add to cart failed', err))
    .finally(() => {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    });
});

if (!customElements.get('card-size-drawer')) {
  customElements.define(
    'card-size-drawer',
    class CardSizeDrawer extends HTMLElement {
      connectedCallback() {
        if (document.querySelector('card-size-drawer[data-init]')) {
          this.remove();
          return;
        }
        this.setAttribute('data-init', '');

        this._overlay = this.querySelector('.card-size-drawer__overlay');
        this._panel = this.querySelector('.card-size-drawer__panel');
        this._summary = this.querySelector('.card-size-drawer__summary');
        this._coloursEl = this.querySelector('.card-size-drawer__colours');
        this._sizeGrid = this.querySelector('.card-size-drawer__sizes');
        this._atcBtn = this.querySelector('.card-size-drawer__atc');
        this._closeBtn = this.querySelector('.card-size-drawer__close');

        this._onTriggerClick = this._onTriggerClick.bind(this);
        this._close = this._close.bind(this);
        this._onSizeClick = this._onSizeClick.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);

        document.addEventListener('click', this._onTriggerClick);
        this._overlay?.addEventListener('click', this._close);
        this._closeBtn?.addEventListener('click', this._close);
        this._atcBtn?.addEventListener('click', this._onAtcClick.bind(this));
        this._sizeGrid?.addEventListener('click', this._onSizeClick);
        document.addEventListener('keyup', this._onKeyUp);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this._onTriggerClick);
        document.removeEventListener('keyup', this._onKeyUp);
      }

      _onTriggerClick(event) {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest('.js-card-size-trigger');
        if (!trigger) return;

        event.preventDefault();

        let sizes;
        try {
          sizes = JSON.parse(trigger.dataset.sizes || '[]');
        } catch {
          sizes = [];
        }

        let siblings;
        try {
          siblings = JSON.parse(trigger.dataset.siblings || '[]');
        } catch {
          siblings = [];
        }

        this._populate(
          trigger.dataset.productTitle || '',
          trigger.dataset.productPrice || '',
          trigger.dataset.productPriceCompare || '',
          trigger.dataset.productImage || '',
          sizes,
          trigger.dataset.productUrl || '',
          trigger.dataset.productVendor || '',
          trigger.dataset.productColour || '',
          siblings
        );
        this._open();
      }

      _populate(title, price, price_compare, image, sizes, url, vendor, colour, siblings) {
        if (this._summary) {
          this._summary.innerHTML = `
            ${image ? `<img src="${image}" alt="" width="80" height="80" loading="lazy" class="card-size-drawer__thumb">` : ''}
            <div class="card-size-drawer__summary-info">
              ${vendor ? `<span class="card-size-drawer__summary-vendor">${vendor}</span>` : ''}
              <span class="card-size-drawer__summary-title">${title}</span>
              <span class="flex items-center gap-1">
              ${price_compare > price ? `<span class="card-size-drawer__summary-price-compare">${price_compare}</span>` : ''}
              <span class="card-size-drawer__summary-price">${price}</span>
            </div>
          `;
        }

        if (this._coloursEl) {
          if (colour || (siblings && siblings.length)) {
            const swatchesHtml = (siblings && siblings.length)
              ? siblings.map((s) => {
                  const style = s.color ? ` style="background:${s.color}"` : '';
                  if (s.active) {
                    return `<span class="linked-products__option active" aria-label="${s.title}"><span class="linked-products__option-color"${style}></span></span>`;
                  }
                  return `<a href="${s.url}" class="linked-products__option" aria-label="${s.title}"><span class="linked-products__option-color"${style}></span></a>`;
                }).join('')
              : '';
            this._coloursEl.innerHTML = `
              <div class="card-size-drawer__colour-row">
                ${colour ? `<span class="card-size-drawer__colour-label">${colour}</span>` : ''}
                <div class="linked-products__options card-size-drawer__swatches">${swatchesHtml}</div>
              </div>
            `;
            this._coloursEl.hidden = false;
          } else {
            this._coloursEl.hidden = true;
          }
        }

        if (this._sizeGrid) {
          this._sizeGrid.innerHTML = sizes
            .map(
              (s) => `
              <button
                type="button"
                class="card-size-drawer__size-btn${s.available ? '' : ' card-size-drawer__size-btn--oos'}"
                data-variant-id="${s.id}"
                data-unavailable="${s.available ? 'false' : 'true'}"
                ${s.available ? '' : 'aria-disabled="true"'}
              >
                ${s.value}
              </button>
            `
            )
            .join('');
        }

        if (this._atcBtn) {
          this._atcBtn.dataset.url = url;
          this._atcBtn.disabled = true;
          this._atcBtn.removeAttribute('data-variant-id');
        }

        this._selectedVariantId = null;
      }

      _onSizeClick(event) {
        const btn = event.target.closest('.card-size-drawer__size-btn');
        if (!btn || btn.dataset.unavailable === 'true') return;

        this._sizeGrid.querySelectorAll('.card-size-drawer__size-btn').forEach((b) => {
          b.classList.remove('is-selected');
          b.removeAttribute('aria-pressed');
        });

        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');

        this._selectedVariantId = btn.dataset.variantId;
        if (this._atcBtn) {
          this._atcBtn.disabled = false;
          this._atcBtn.dataset.variantId = this._selectedVariantId;
        }
      }

      _onAtcClick() {
        const variantId = this._atcBtn?.dataset.variantId;
        if (!variantId) return;

        this._atcBtn.disabled = true;
        this._atcBtn.classList.add('is-loading');

        addToCart(variantId)
          .then(() => this._close())
          .catch((err) => console.warn('[size-drawer] add to cart failed', err))
          .finally(() => {
            if (this._atcBtn) {
              this._atcBtn.disabled = false;
              this._atcBtn.classList.remove('is-loading');
            }
          });
      }

      _open() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        this._closeBtn?.focus();
      }

      _close() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }

      _onKeyUp(event) {
        if (event.code === 'Escape' && this.hasAttribute('open')) this._close();
      }
    }
  );
}

} // end __kbxSizePickerInit
